// extracted by mini-css-extract-plugin
export default {"commentBox":"gYwKM2"};